import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { MediaData, ParagraphOutputMedia } from "@/model/paragraph";
import { removeMediaData } from "@/util/helper/paragraphHelper";

import { ParagraphInputsProps } from "../model";
import { MediaInput, MediaPreview } from "../input";


const ParagraphOutputMediaCardInputs: React.FC<ParagraphInputsProps<ParagraphOutputMedia>> = (props) => {
    const { paragraph, onChange } = props;

    const intl = useIntl();

    const [mediaData, setMediaData] = useState<MediaData>(paragraph.data ?? {});

    const handleChange = (value: MediaData) => {
        setMediaData(value);
        onChange({ ...paragraph, data: value });
    };

    useEffect(() => {
        setMediaData(paragraph.data ?? {});
    }, [paragraph.data]);

    return (
        <div className="col-span-2 flex flex-col gap-1.5">
            <div className="field-label">
                {intl.formatMessage({ id: "i04044" })}
            </div>
            <div className="flex flex-col gap-2">
                <MediaInput data={mediaData}
                            onChange={value => handleChange({ ...removeMediaData(paragraph), ...value })}
                />
                {!!mediaData.media_type && !!mediaData.media_url && (
                    <MediaPreview mediaType={mediaData.media_type}
                                  mediaUrl={mediaData.media_url}
                                  width={300}
                                  height={mediaData.media_type === "video" ? 170 : undefined}
                    />
                )}
            </div>
        </div>
    );
};

export default ParagraphOutputMediaCardInputs;
